import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "./useAllowFeature";

export function useIsClassesEnabled(): boolean {
    const { hasAccess, isFetched } = useAllowFeature(PREMIUM_FEATURES.CLASSES);

    return !isFetched || hasAccess;
}
